import React from "react";
import { Check } from "lucide-react";

const columns = [
  {
    title: "Workplace Safety",
    items: [
      "Permit-to-Work (PTW) systems",
      "Fire & life safety review",
      "Electrical safety & LOTO",
      "Working at heights / scaffolding",
      "Confined space entry",
      "Machine guarding & ergonomics",
    ],
  },
  {
    title: "Risk & Compliance",
    items: [
      "HIRA · HAZOP · JHA",
      "ISO 45001 / 14001 / 9001 readiness",
      "Statutory compliance tracker",
      "Contractor management audit",
      "Document & SOP library review",
      "MOC (Management of Change)",
    ],
  },
  {
    title: "Incident & Emergency",
    items: [
      "Incident investigation & RCA",
      "CAPA tracking & closure",
      "Emergency response plan review",
      "Evacuation & mock drills",
      "Near-miss reporting culture",
      "Behavioural safety observation",
    ],
  },
  {
    title: "Environment & ESG",
    items: [
      "HAZMAT handling & storage",
      "Spill response readiness",
      "Waste & effluent compliance",
      "Carbon footprint baseline",
      "ESG reporting frameworks",
      "Energy & resource audit",
    ],
  },
];

export default function AuditChecklist() {
  return (
    <section
      data-testid="audit-checklist"
      id="audit-checklist"
      className="bg-white border-t border-line"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-7">
            <p className="mono-label">Audit-based approach</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight mt-5 leading-[0.95]">
              What a Sabari
              <br />
              audit actually
              <br />
              <span className="text-accent-red">covers</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-ink/70 leading-relaxed">
              Twenty-four checkpoints across four domains. Every audit closes
              with a prioritised gap register, a defensible CAPA plan, and a
              live tracker your leadership can review month-on-month.
            </p>
          </div>
        </div>

        <div
          data-testid="checklist-grid"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line"
        >
          {columns.map((col, ci) => (
            <div
              key={col.title}
              data-testid={`checklist-col-${ci}`}
              className="bg-white p-6 lg:p-7 flex flex-col"
            >
              <div className="flex items-center justify-between pb-3 mb-5 border-b border-line">
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-muted">
                  Domain 0{ci + 1}
                </span>
                <span className="font-mono text-[10px] text-accent-red">
                  06 items
                </span>
              </div>
              <h3 className="font-display text-xl uppercase tracking-tight leading-tight">
                {col.title}
              </h3>
              <ul className="mt-6 space-y-3.5">
                {col.items.map((it) => (
                  <li
                    key={it}
                    className="flex items-start gap-3 text-sm text-ink/80"
                  >
                    <span className="mt-0.5 w-4 h-4 border border-accent-red text-accent-red flex items-center justify-center shrink-0">
                      <Check size={11} strokeWidth={3} />
                    </span>
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-8 border-t border-line">
          <p className="font-mono text-xs text-ink-muted uppercase tracking-[0.15em]">
            Each engagement is scoped to your site — typical audit duration: 3–10 days.
          </p>
          <button
            data-testid="audit-cta"
            onClick={() =>
              document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })
            }
            className="btn-dark"
          >
            Request an EHS Audit →
          </button>
        </div>
      </div>
    </section>
  );
}
